import React from 'react';
import { useStaticQuery, graphql } from "gatsby"
import UpdateTeaser from './updateteaser';

export default function LatestPosts() {
	const data = useStaticQuery(graphql`
    query getTopThreePosts {
        updates: allWpPost(
          filter: {tags: {nodes: {elemMatch: {name: {eq: "promotions"}}}}}
          limit: 3
        ) {
          nodes {
            id
            excerpt
            content
            title
            date(formatString: "MMMM DD, YYYY")
            uri
            featuredImage {
              node {
                altText
                localFile {
                  childImageSharp {
                    gatsbyImageData(quality: 100, placeholder: BLURRED, layout: FULL_WIDTH)
                  }
                }
              }
            }
          }
        }
      }      
    `)

	return (
		<>
			<section className="section-blog latest-posts">
				<div className="container">
					<div className="title">
						<h2>LATEST Promotions</h2>
					</div>

					<div className="bloglist">
						<div className="row">
							{
								data.updates.nodes.map(updatepost => {
									return (
										<div className="col-md-4 col-lg-4 col-sm-12" id={updatepost.id} key={updatepost.id}>
											<UpdateTeaser data={updatepost} key={updatepost.id} />
										</div>
									)
								})
							}
						</div>
						<div className="get-button">
							<a href="/promotions" className="btn btn-play">View More</a>
						</div>
					</div>
				</div>
				<div className="topslant">
					<svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="1320" height="50" viewBox="0 0 1310 1">
						<defs>
							<clipPath id="clip-path">
								<path id="Mask" d="M0,48.5H648.553L676,0h566l27.447,48.5H1920v666H0Z" transform="translate(0 0.5)" />
							</clipPath>
						</defs>
						<g id="footer-top" transform="translate(0 -0.5)">
							<path id="Mask-2" data-name="Mask" d="M0,48.5H648.553L676,0h566l27.447,48.5H1920v666H0Z" transform="translate(0 0.5)" fill="#0c0f0b" />
						</g>
					</svg>
				</div>
			</section>
		</>
	)

}